export { default } from './contactTypes.reducer';
